import { render, staticRenderFns } from "./HolidaySale.vue?vue&type=template&id=4c8568a9&"
import script from "./HolidaySale.vue?vue&type=script&lang=ts&"
export * from "./HolidaySale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports